$(document).on(
  "change",
  ".mod-owner-dashboard.movie form input[type=checkbox]",
  function (event) {
    var form = $(this).parents("form").get(0);
    Rails.fire(form, "submit");
  }
);
